import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const SessionDescriptionDialog = ({ open, row, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle
      sx={{
        fontSize: 18,
        fontWeight: 500,
        borderBottom: "1px solid #ddd",
        pb: 1,
      }}
    >
      Sesión {row?.nroSesion}
    </DialogTitle>

    <DialogContent sx={{ pt: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        {row?.tema}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          lineHeight: 1.7,
          color: "#444",
          whiteSpace: "pre-line",
        }}
      >
        {row?.descripcion}
      </Typography>
    </DialogContent>

    <DialogActions
      sx={{
        borderTop: "1px solid #ddd",
        px: 3,
        py: 1,
        justifyContent: "flex-end",
      }}
    >
      <Button onClick={onClose}>CERRAR</Button>
    </DialogActions>
  </Dialog>
);

export default SessionDescriptionDialog;
